import React from 'react';

import cx from 'classnames';
import { useDispatch } from 'react-redux';

import { MANUALLY_FLIGHT } from 'components/Pages/Admin/GuestPortal/Flights/AddManually/utils';
import { openModalAction } from 'store/modal';

import s from './index.module.css';

export function Footer(props) {
  const { isManually = false, itemIndex } = props;
  const dispatch = useDispatch();

  const handleOpenManuallyModal = () => {
    dispatch(
      openModalAction({
        type: 'ADD_MANUALLY',
        data: { itemIndex, formType: MANUALLY_FLIGHT },
      }),
    );
  };

  const handleOpenSearchModal = () => {
    dispatch(
      openModalAction({
        type: 'ADD_FLIGHTS',
        data: { itemIndex },
      }),
    );
  };

  const handleManuallyClick = () => {
    if (isManually) {
      return handleOpenSearchModal();
    }

    return handleOpenManuallyModal();
  };

  return (
    <div className={cx(s.manually, 'custom-add-flights-manually')}>
      or{' '}
      <button
        type="button"
        className={cx(s.manuallyBtn, 'btn-reset', 'custom-add-flights-manually-btn')}
        onClick={handleManuallyClick}
      >
        {isManually ? 'Search' : 'Add flights manually'}
      </button>
    </div>
  );
}
